import { FuelHTLCPublicClient } from './PublicClient.js';
import { buildRedeemSolverTx } from './wallet/buildRedeemSolverTx.js';
import { buildRefundTx } from './wallet/buildRefundTx.js';
import { buildUserLockTx } from './wallet/buildUserLockTx.js';
import { redeemSolver } from './wallet/redeemSolver.js';
import { refund } from './wallet/refund.js';
import { userLock } from './wallet/userLock.js';
export class FuelHTLCWalletClient extends FuelHTLCPublicClient {
    constructor(config) {
        super(config);
        this.signer = config.signer;
    }
    async userLock(params) {
        return userLock(this.signer, params);
    }
    async refund(params) {
        return refund(this.signer, params);
    }
    async redeemSolver(params) {
        return redeemSolver(this.signer, params);
    }
    // ── Transaction Builders ──────────────────────────────────────────
    async buildUserLockTx(params) {
        return buildUserLockTx(this.signer, params);
    }
    async buildRefundTx(params) {
        return buildRefundTx(this.signer, params);
    }
    async buildRedeemSolverTx(params) {
        return buildRedeemSolverTx(this.signer, params);
    }
}
